<template>
  <!--
    name: 覃刚
    function: 原料数据库
    date: 2021-03-01
 -->
  <div class="listContent">
    <a-form :form="form" class="headForm" layout="inline" style="display: flex; align-items: center; flex-wrap: nowrap; white-space: nowrap;">
      <a-form-item label="原料">
        <a-input style="width: 150px" @change="changeName" v-decorator="['name']" placeholder="输入原料名称/代码" />
      </a-form-item>

      <a-form-item v-if="overseasFlag == 1" label="原料别名">
        <a-input style="width: 150px" @pressEnter="getList({ current: 1, pageSize: pagination.pageSize })" v-decorator="['aliasName']" placeholder="请输入原料别名" />
      </a-form-item>

      <a-form-item label="原料类型">
        <a-cascader style="width: 200px" v-decorator="['typeArr']" :options="typeList" :load-data="loadData" placeholder="选择原料类型" change-on-select />
      </a-form-item>

      <a-form-item label="可耗用天数排序">
        <a-select style="width: 150px" v-decorator="['turnoverDayOrder']" placeholder="可耗用天数排序" @change="onTurnoverOrderChange" allowClear>
          <a-select-option :value="1">可耗用天数由低到高</a-select-option>
          <a-select-option :value="2">可耗用天数由高到低</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="库存量排序">
        <a-select style="width: 150px" v-decorator="['storageWeightOrder']" placeholder="库存量排序" @change="onStorageOrderChange" allowClear>
          <a-select-option :value="1">库存量由低到高</a-select-option>
          <a-select-option :value="2">库存量由高到低</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item style="margin-left: 16px">
        <a-space>
          <a-button type="primary" class="btnMar" @click="getList({ current: 1, pageSize: pagination.pageSize })">查询</a-button>
          <a-button class="btnMar2" @click="resetFields">清空</a-button>
        </a-space>
      </a-form-item>
    </a-form>

    <div class="editBox" style="height: 44px">
      <!-- 一些按钮 -->
      <span v-for="el in btnList2" :key="el.id">
        <a-button :type="el.code === 'add' ? 'primary' : el.code === 'delete' ? 'danger' : ''
          " :ghost="el.code === 'delete'" @click="clickFunc(el.path, el.code)"
          :disabled="selectedRows.length === 0 && el.code === 'edit'">{{ el.name }}
        </a-button>
      </span>
      <a-button :disabled="selectList.length == 0" @click="copyData('copy')">批量复制</a-button>
      <a-button :disabled="selectList.length == 0" @click="batchLims">批量应用LIMS检测数据</a-button>
      <span v-if="selectList.length > 0" style="
          background: #fafafa;
          border: 1px solid #d9d9d9;
          padding: 3px 5px;
          border-radius: 5px;
          font-size: 12px;
        ">已选中 {{ selectList.length }}条原料</span>
      <div style="float: right; display: flex">
        <!-- <a-select v-model="priceField" style="width: 120px;margin-right: 20px">
          <a-select-option value="privateContractPrice">
            合同价格
          </a-select-option>
          <a-select-option value="privateStockPrice">
            库存价格
          </a-select-option>
          <a-select-option value="privateMarketPrice">
            市场价格
          </a-select-option>
          <a-select-option value="privatePredictionPrice">
            预测价格
          </a-select-option>
        </a-select> -->
        <a-tooltip placement="top">
          <template slot="title">
            <span>批量导入原料</span>
          </template>
          <div @click="showExport" class="resetBox" style="margin-right: 10px; font-size: 16px">
            <a-icon type="upload" />
          </div>
        </a-tooltip>
        <!-- 曾静修改---------------- -->
        <!-- 差异对比按钮 -->
        <a-tooltip placement="top">
          <template slot="title">
            <span>原料营养指标对比</span>
          </template>
          <div @click="showDifferContrastModal" class="resetBox" style="margin-right: 10px; font-size: 14px">
            VS
          </div>
        </a-tooltip>

        <a-tooltip placement="top">
          <template slot="title">
            <span>原料显示列</span>
          </template>

          <a-dropdown>
            <div class="resetBox" style="margin-right: 10px; font-size: 14px">
              <a-icon type="filter" />
            </div>
            <a-menu slot="overlay" class="col-filter-menu">
              <a-checkbox-group :defaultValue="colFilterResult" name="checkboxgroup" :options="colFilterOptions"
                @change="onColFilterChange" />
            </a-menu>
          </a-dropdown>

        </a-tooltip>

        <!-- <div class="resetBox" @click="resetList">
          <a-tooltip>
            <template slot="title"> 更新原料价格 </template>
            <a-icon type="redo" />
          </a-tooltip>
        </div> -->

        <!-- <a-button @click="resetList" >
          更新
        </a-button> -->
        <!-- <a-icon type="redo" /> -->
      </div>
    </div>
    <a-config-provider>
      <template #renderEmpty>
        <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(0 1)" fill="none" fillRule="evenodd">
            <ellipse fill="#F5F5F5" cx="32" cy="33" rx="32" ry="7"></ellipse>
            <g fillRule="nonzero" stroke="#D9D9D9">
              <path
                d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z">
              </path>
              <path
                d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                fill="#FAFAFA"></path>
            </g>
          </g>
        </svg>
        <p style="color: #ccc; font-size: 13px">暂无数据</p>
        <a-button type="primary" @click="showAddFunc">导入原料</a-button>
      </template>
      <resize-table ref="listRef" bordered :scroll="{ y, x: 200 }" :columns="columns" :data-source="list"
        class="tableBox" :row-selection="rowSelection" :pagination="pagination" :locale="locale" rowKey="id">

        <template slot="rawReference" slot-scope="t, r">
          {{ r.rawReference ? r.rawReference.name : "" }}
        </template>

        <template slot="aliasName" slot-scope="text, record">
          <cell-editor-text style="width: 100%" :item="record" name="aliasName"
            @blur="(target) => itemUpdate(target, 'aliasName')" :text="text" :actions="(e) => update(e, 'aliasName')"
            :background="true" />
        </template>

        <div slot="status" slot-scope="text, record">
          <span :style="{ color: !text ? 'green' : 'red' }">
            {{ !text ? "激活" : "失效" }}</span>/
          {{ record.categoryTypeName ? record.categoryTypeName : "-" }}
        </div>

        <a slot="rawOrder" slot-scope="t, record" @click="handlerMore({ key: 2 }, record)">
          {{ t || t === 0 ? t : "排序" }}
        </a>

        <template v-for="el in [
          'privateContractPrice',
          'privateStockPrice',
          'privateMarketPrice',
          'privatePredictionPrice',
          'fixRatio',
          'minWeightVal',
        ]" :slot="el" slot-scope="text, record">
          <span :key="el">
            <cell-editor style="width: 100%" :len="3" :precision="3" :item="record" :name="el"
              :min="el === 'fixRatio' || el === 'minWeightVal' ? -9999999.999 : 0" :max="el === 'fixRatio' || el === 'minWeightVal'
                ? 9999999.999
                : 999999999999.999
                " @blur="(target) => itemUpdate(target, el)" :text="text" :actions="(e) => update(e, el)"
              :background="true" class="setEditor" />
          </span>
        </template>

        <span slot="customTitle"><a-icon @click="fixedCol" type="pushpin" :theme="filled ? 'filled' : 'outlined'" />
          原料名称
        </span>

        <template slot="name" slot-scope="text, record, index">
          <a-tooltip>
            <template slot="title">
              {{ text }}
            </template>
            <a @click="scanPriceList(text, record, index)" class="nameStyle">{{
              text
            }}</a>
          </a-tooltip>
        </template>

        <template slot="rawTypeName" slot-scope="text, record">
          <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record)">
            <template slot="title">
              {{ record.fullTypeName }}
            </template>
            <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
          </a-tooltip>
        </template>

        <template slot="options" slot-scope="text, record, index">
          <a @click="scanPriceList(text, record, index)">查看养分</a>
          <a-divider type="vertical" />
          <a @click="coverData(record)">覆盖</a>
          <a-divider type="vertical" />
          <a @click="copyData(record)">复制</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> ... </a>
            <a-menu slot="overlay" @click="(e) => handlerMore(e, record)">
              <a-menu-item key="2"> 排序 </a-menu-item>
              <a-menu-item key="3"> 查看 </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>

        <template slot="storageWeight" slot-scope="text, record">
          <a @click="viewBatchStorage(record)" class="nameStyle">
            {{ text || text === 0 ? Number(text).toFixed(3) : text }}
          </a>
        </template>

        <template slot="turnoverDayTitle">
          <label>可耗用天数</label>
          <a-tooltip style="position: relative;top: 1px;margin-left: 4px">
            <template slot="title">期末库存量/近30日平均耗用量</template>
            <a-icon type="exclamation-circle" />
          </a-tooltip>
        </template>

        <template slot="turnoverDay" slot-scope="text, record">
          <a-tooltip v-if="turnoverDayTip(record)" style="margin-right: 4px;">
            <template slot="title">
              高库存原料：{{ record.purchaseClass + ' > ' + (record.purchaseClassCode === '1001' ? '15' : '30') }}天
            </template>
            <a-icon type="info-circle" style="color: orange;" />
          </a-tooltip>
          <label :style="{ color: turnoverDayTip(record) ? 'orange' : '' }">{{ text }}</label>
        </template>
      </resize-table>
    </a-config-provider>

    <!-- 新增 -->
    <a-modal :visible="showAdd" :confirm-loading="confirmLoading" @cancel="showAddFunc" :maskClosable="false"
      width="1000px" destroyOnClose class="modalStyle">
      <p slot="title">
        <a-alert message="请添加原料到您的工厂中" banner />
      </p>
      <MaterialAdd ref="add" :typeList="typeList" @getTypeList="refreshTypeList" :leftTitle="leftTitle"
        :rightTitle="rightTitle" />
      <div slot="footer" style="text-align: right">
        <!-- <a-button @click="showAddFunc">关闭</a-button> -->
        <a-button @click="showAddFunc">取消</a-button>
        <a-button type="primary" :loading="submitLoading" @click="addSubmit">确定</a-button>
      </div>
    </a-modal>


    <!-- 替换原料显示 -->
    <a-modal :visible="showReplace" :confirm-loading="confirmLoading" @cancel="showReplaceFunc" :maskClosable="false"
      width="1000px" destroyOnClose class="modalStyle">
      <MaterialReplace ref="add" :dataList="dataList" />
      <div slot="footer" style="text-align: right">
        <!-- <a-button @click="showAddFunc">关闭</a-button> -->
        <!--        <a-button @click="showReplaceFunc">取消</a-button>-->
        <a-button type="primary" @click="replaceSubmit">确定导入替换原料</a-button>
      </div>
    </a-modal>

    <mater-drawer ref="MaterDrawer" :marterArr="selectedRows" />

    <!-- 曾静修改---------------- -->
    <!-- 原料差异对比模态框 -->
    <differContrast ref="differContrast"></differContrast>
    <cover-modal ref="CoverModal" />
    <copy-modal ref="CopyModal" />
    <!-- exportVisible -->
    <ExportModel :visible="exportVisible" @closeExport="showExport" />

    <!-- 批量应用LIMS数据 -->
    <batchlims-drawer :visible="batchlimsVisible" :selected-rows="selectedRows"
      @close="onBatchLimsClose"></batchlims-drawer>

    <!-- 查看批次库存 -->
    <a-modal title="查看批次库存" :visible="batchStorageModalVisible" width="600px" destroyOnClose :footer="null"
      @cancel="onBatchStorageClose">
      <a-table bordered :columns="batchStorageColumns" :data-source="batchStorageData" :loading="batchStorageLoading">
        <template slot="totalQuantity" slot-scope="text">
          {{ text || text === 0 ? Number(text / 1000).toFixed(3) : text }}
        </template>
      </a-table>
    </a-modal>

    <!-- 排序弹窗 -->
    <sort-modal :hidden="sortModalVisible" @close="hideSortModal" :rowData="sortData" />
  </div>
</template>
<script>
import MaterialAdd from "./MaterialEdit/MaterialAdd.vue";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import CellEditor from "./MaterialEdit/CellEditor.vue";
import CellEditorText from "./MaterialEdit/CellEditorText.vue";
import CoverModal from './MaterialEdit/CoverModal.vue';
import CopyModal from './MaterialEdit/CopyModal.vue';
import MaterDrawer from './MaterialEdit/MaterDrawer.vue';
import ExportModel from './MaterialEdit/ExportModel.vue';
import differContrast from "./MaterialEdit/differContrast.vue";
import MaterialReplace from "./MaterialEdit/MaterialReplace.vue";
import BatchlimsDrawer from "./MaterialEdit/BatchlimsDrawer.vue";
import SortModal from './MaterialEdit/SortModal.vue';

import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    MaterialAdd,
    MaterialReplace,
    MaterDrawer,
    CellEditor,
    differContrast,
    CellEditorText,
    CoverModal,
    CopyModal,
    ExportModel,
    BatchlimsDrawer,
    SortModal
  },
  data() {
    return {
      overseasFlag: window.localStorage.getItem("overseasFlag"),
      filled: true,
      leftTitle: "",
      rightTitle: window.localStorage.getItem("factoryName"),
      searchKey: "",
      inputVal: "",
      placeStr: "请输入指标名称",
      searchList: [],
      loading: false,
      recordObj: {},
      y: 500,
      locale,
      form: this.$form.createForm(this, { name: "rawMaterialList" }),
      priceField: "privateMarketPrice",
      typeList: [],
      dataList: [],
      oldList: [],
      selectList: [],
      confirmLoading: false,
      submitLoading: false, // 提交按钮加载状态，防止重复点击
      showAdd: false, // 是否显示新增
      showEdit: false, // 是否显示编辑
      showReplace: false,//是否显示替换原料
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },

      batchlimsVisible: false, // 批量应用lims
      pagination: {
        pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
        locale,
        total: 0,
        pageSize: 0,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.getList({ current, pageSize });
        }, //选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1;
          this.pagination.pageSize = pageSize;
          window.localStorage.setItem('materialManagementPageSize', pageSize);
          this.getList({ current: 1, pageSize });
        }, //每页多少条
      },
      list: [
        // {edit: false,'privateContractPrice':1,'privateStockPrice':2,'privateMarketPrice':3,'privatePredictionPrice':4,'fixRatio':5,'minWeightVal':6}
      ],
      list2: [],
      columnsAll: [
        {
          title: "原料名称",
          dataIndex: "name",
          width: 160,
          ellipsis: true,
          slots: { title: "customTitle" },
          scopedSlots: { customRender: "name" },
          sorter: (a, b) => a.name.localeCompare(b.name, "zh"),
        },
        {
          title: "原料别名",
          dataIndex: "aliasName",
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: "aliasName" },
          sorter: (a, b) => a.aliasName.localeCompare(b.aliasName, "zh"),
        },
        {
          title: "代码",
          dataIndex: "code",
          width: 120,
          ellipsis: true,
          sorter: (a, b) => a.code.localeCompare(b.code, "zh"),
        },
        {
          title: "类型",
          width: 120,
          ellipsis: true,
          dataIndex: "rawTypeName",
          sorter: (a, b) => a.rawTypeName.localeCompare(b.rawTypeName, "zh"),
          scopedSlots: { customRender: 'rawTypeName' },
        },
        {
          title: "市场价格",
          dataIndex: "privateMarketPrice",
          width: 100,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: "privateMarketPrice" },
          sorter: (a, b) => a.privateMarketPrice - b.privateMarketPrice,
        },
        {
          title: "库存价格",
          dataIndex: "privateStockPrice",
          width: 100,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: "privateStockPrice" },
          sorter: (a, b) => a.privateStockPrice - b.privateStockPrice,
        },
        {
          title: "合同价格",
          dataIndex: "privateContractPrice",
          width: 100,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: "privateContractPrice" },
          sorter: (a, b) => a.privateContractPrice - b.privateContractPrice,
        },
        {
          title: "预测价格",
          dataIndex: "privatePredictionPrice",
          width: 100,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: "privatePredictionPrice" },
          sorter: (a, b) => a.privatePredictionPrice - b.privatePredictionPrice,
        },
        {
          title: "取整系数(KG)",
          dataIndex: "fixRatio",
          width: 120,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: "fixRatio" },
          sorter: (a, b) => a.fixRatio - b.fixRatio,
        },
        {
          title: "最小称量量(KG)",
          dataIndex: "minWeightVal",
          width: 120,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: "minWeightVal" },
          sorter: (a, b) => a.minWeightVal - b.minWeightVal,
        },
        {
          title: "库存量",
          dataIndex: "storageWeight",
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "storageWeight" },
        },
        {
          // title: "可耗用天数",
          dataIndex: "turnoverDay",
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { title: 'turnoverDayTitle', customRender: "turnoverDay" },
        },
        {
          title: "参考原料",
          dataIndex: "rawReference",
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "rawReference" },
        },
        {
          title: "养分最新维护时间",
          dataIndex: "nutritionLastUpdateTime",
          width: 160,
        },
        {
          title: "单位",
          dataIndex: "unit",
          width: 80,
          ellipsis: true,
        },
        {
          title: '状态/类目归属',
          dataIndex: 'status',
          width: 120,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: "排序",
          dataIndex: "rawOrder",
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: "rawOrder" },
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 160,
          ellipsis: true,
        },

        {
          title: "操作",
          dataIndex: "options",
          fixed: 'right',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: "options" },
        },
      ],
      marterArr: [],
      selectedRows: [], //保存选中的数组对象
      updateMaterials: false, //是否开启多原料修改
      btnList2: [],
      exportVisible: false,

      colFilterResult: [],

      batchStorageModalVisible: false,
      batchStorageLoading: false,
      batchStorageColumns: [
        {
          title: "批次",
          dataIndex: "batchNumber",
          width: 160,
          ellipsis: true,
          align: 'center',
        },
        {
          title: "批次量(Ton)",
          dataIndex: "totalQuantity",
          width: 160,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: "totalQuantity" },
        },
      ],
      batchStorageData: [],
      sortData: {},
      sortModalVisible: false,
    };
  },
  computed: {
    ...mapState('material', ['materialCount']),
    pageSizeC() {
      let pageSize = window.localStorage.getItem('materialManagementPageSize');
      let pageSizeC = pageSize ? Number(pageSize) : 20;
      return pageSizeC;
    },
    rowSelection() {
      return {
        // columnTitle:' ',
        onChange: (selectedRowKeys, selectedRows) => {
          if (selectedRowKeys.length > 20) {
            // this.$message.warning('最多可以选中20个原料')
          } else {
            this.selectList = selectedRowKeys;
            selectedRows.forEach((el) => {
              if (
                this.selectedRows.filter((item) => item.id === el.id).length ===
                0
              )
                this.selectedRows.push(el);
            });
            this.selectedRows = this.selectedRows.filter((el) =>
              this.selectList.includes(el.id)
            );
          }
          this.list = [...this.list];
          // if(this.selectedRows.length > 0){
          //   this.updateMaterials = this.selectedRows.every(
          //     (item) => item.isFucCal == 1
          //   );
          // }else{
          //   this.updateMaterials = false
          // }
        },
        selectedRowKeys: this.selectList,
        onSelectAll: (selected, selectedRows, changeRows) => {
          if (selected) {
            changeRows.forEach((el) => {
              if (
                this.selectList.length < 20 &&
                !this.selectList.includes(el.id)
              ) {
                this.selectList.push(el.id);
                this.selectedRows.push(el);
              }
            });
            this.list = [...this.list];
          } else {
            this.selectList = [];
            let list = [];
            let ids = changeRows.map(el => el.id);
            this.selectedRows.forEach(el => {
              if (!ids.includes(el.id)) list.push(el.id);
            });
            this.selectedRows = list;
          }
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled:
              !this.selectList.includes(record.id) &&
              this.selectList.length >= 20,
          },
        }),
      };
    },
    columns() {
      let columns = this.columnsAll.filter(
        (el) => (el.dataIndex !== "aliasName" || this.overseasFlag == "1") && this.colFilterResult.includes(el.dataIndex)
      );
      if (this.filled) {
        columns[0].fixed = "left";
      } else {
        delete columns[0].fixed;
      }
      return columns;
    },
    colFilterOptions() {
      return this.columnsAll.map(col => {
        if (col.dataIndex === 'turnoverDay')
          return { label: '可耗用天数', value: col.dataIndex };
        else
          return { label: col.title, value: col.dataIndex };
      });
    }
  },
  created() {
    const MaterialManagementColsFilterResult = window.localStorage.getItem('MaterialManagementColsFilterResult')?.split(',');
    this.colFilterResult = MaterialManagementColsFilterResult || this.columnsAll.map(col => col.dataIndex).filter(col => col !== 'rawTypeName' && col !== 'unit');
    this.getList();
    this.getTypeList();
    this.getReplaceInfo();

  },
  watch: {
    btnList: {
      handler(val) {
        this.dealBtnList(val);
      },
      deep: true,
    },
    materialCount() {
      this.getList();
    },
  },
  mounted() {
    this.dealBtnList(this.btnList);
    this.y = this.$refs.listRef.$el.offsetHeight - 116;
  },
  methods: {
    ...mapMutations('material', ['setState']),
    showExport(type) {
      setTimeout(() => {
        this.exportVisible = !this.exportVisible;
        if (type === 'refresh') this.getList(this.pagination);
      }, 300);
    },
    afterSave() {
      this.selectList = [];
      this.selectedRows = [];
    },
    fixedCol(e) {
      this.filled = !this.filled;
      e = e || window.event;
      if (e.stopPropagation) {
        //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    async update(arg, field) {
      if (field === "aliasName") {
        let val = arg.aliasName;
        let reg =
          /[`~!@$^&_+=<>?:"{}|,.;'\\[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
        if (!reg.test(val)) {
          if (!val) arg.aliasName = null;
          arg = { ...arg, name: '' };
          await this.$post("/nhf-app/factorystaffraw/update", arg);
        } else {
          this.$message.warning("请不要输入非法字符");
        }
      } else {
        arg.aliasName = !arg.aliasName ? null : arg.aliasName;
        // 使用统一的验证和修正方法
        arg[field] = this.validateAndCorrectValue(arg[field], field);
        await this.$post("/nhf-app/factorystaffraw/update", arg);
      }
      return {};
    },
    itemUpdate(item, feild) {
      let val = item[feild];
      let record = this.list.filter((el) => el.id === item.id)[0];
      if (feild === "aliasName") {
        let reg = /[`~!@$^&_+=<>?:"{}|,.;'\\[\]·~！@￥……&——+={}|《》？：“”【】、；‘’，。、]/im;
        if (!reg.test(val)) {
          record[feild] = val;
        } else {
          record[feild] = null;
        }
      } else {
        // 使用统一的验证和修正方法
        record[feild] = this.validateAndCorrectValue(val, feild);
      }

      // this.editRow(record,'save')
    },
    dealBtnList(val = []) {
      let menuObj = val.filter((e) => e.code === "materialManagement")[0] || {};
      if (menuObj && menuObj.children && menuObj.children.length) {
        this.btnList2 = menuObj.children || [];
      } else {
        this.btnList2 = [];
      }
    },
    clickFunc(functionName, type) {
      this[functionName](type);
    },
    getMaterialList() {
      this.setState({ marterArr: this.selectedRows });
      setTimeout(() => {
        this.$refs.MaterDrawer.modalShow();
      }, 0);
    },

    // 差异对比
    showDifferContrastModal() {
      this.$refs.differContrast.init();
    },

    inputKeydown(e) {
      if (e.keyCode === 13) this.getList({ current: 1, pageSize: this.pageSizeC });
    },
    onSelect(val) {
      this.getList({ pageSize: this.pagination.pageSize, current: 1, val });
    },
    selectChange(val) {
      console.log("selectChange", val);
    },
    nameBlur(name) {
      this.form.setFieldsValue({ name: this.searchKey || name });
    },
    changeName() {
      setTimeout(() => {
        this.getList({ current: 1, pageSize: this.pagination.pageSize });
      }, 300);
    },
    getSearchList(name) {
      if (name) {
        setTimeout(() => {
          this.placeStr = name || "请输入指标名称";
          this.form.setFieldsValue({ name });
          this.$get("/nhf-app/factorystaffraw/myRawpage", {
            current: 1,
            size: 100,
            factoryId: window.localStorage.getItem("factoryId"),
            name,
          })
            .then((res) => {
              let { success, data } = res;
              if (success) {
                let { records } = data || {};
                records.map((el) => {
                  let nameArr = el.name.split(name);
                  el.firstName = nameArr[0];
                  el.lastName = nameArr[1];
                  el.midName = name;
                  return el;
                });
                this.searchList = records || [];
              } else {
                this.searchList = [];
              }
            })
            .catch(() => {
              this.searchList = [];
            });
        }, 300);
      }
    },
    renderColumns() {
      return this.columns.map((item) => {
        let editArr = [
          "privateContractPrice",
          "privateStockPrice",
          "privateMarketPrice",
          "privatePredictionPrice",
          "fixRatio",
          "minWeightVal",
        ];
        if (editArr.includes(item.dataIndex)) {
          return {
            ...item,
            customCell: (record) => {
              return {
                on: {
                  click: () => {
                    if (this.recordObj.code) return;
                    this.inputVal = record[item.dataIndex];
                    this.editRow(record, "edit", item.dataIndex);
                  },
                },
                style: {
                  background: "#e6f7ff",
                },
              };
            },
          };
        } else {
          return item;
        }
      });
    },
    
    resetList() {
      if (this.selectList.length === 0) {
        // this.$message.warning('请选中需要重置的数据')
        this.$message.warning("请选择需要更新的原料");
      } else {
        this.$confirm({
          title: "提示",
          // content: '确认将选中的原料恢复至基础值吗？',
          content: "确认将选中的原料更新为基础库数据吗？",
          cancelText: "取消",
          okText: "确定",
          onOk: () => {
            let ids = this.selectList.join(",");
            this.$http
              .post(
                `/nhf-app/factorystaffraw/resetFactoryStaffRawIds?ids=${ids}`,
                { ids }
              )
              .then((res) => {
                let { success } = res;
                if (success) {
                  // this.$message.success('重置成功')
                  this.$message.success("更新成功");
                  this.getList();
                } else {
                  // this.$message.error('重置失败')
                  this.$message.error("更新失败");
                }
              });
          },
          onCancel() {
            console.log("取消重置。");
          },
        });
      }
    },
    resetFields() {
      this.placeStr = "请输入指标名称";
      this.searchList = [];
      this.form.resetFields();
    },
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption);
    },
    getTypeList(parentId = 0, record) {
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail');
      let factoryDetail = obj ? JSON.parse(obj) : {};
      let { deptId } = factoryDetail;
      this.$http
        .get(
          `/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=raw&parentId=${parentId}&deptId=${deptId}`
        )
        .then((res) => {
          let { success, data = [] } = res;
          if (success) {
            data &&
              data.map((el) => {
                el.value = el.id;
                el.label = el.name;
                el.isLeaf = !el.hasChildren;
                // el.isLeaf = false
                return el;
              });
            if (record) {
              if (data.length) {
                record.children = data;
              } else {
                record.isLeaf = true;
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data;
            }
            // this.typeList = data
            // return data
          } else {
            this.typeList = [];
          }
        });
    },
    async getReplaceInfo() {
      let factoryId = window.localStorage.getItem('factoryId');
      let staffId = window.localStorage.getItem('staffId');
      if (!factoryId || !staffId) return;
      this.$http.get(`/nhf-app/factorystaffraw/myRawStatusDiff?factoryId=${factoryId}&staffId=${staffId}`).then(res => {
        if (res.data && res.data.length > 0) {
          this.dataList = res.data;
          this.showReplace = true;
        } else {
          this.dataList = [];
        }
      });
    },
    getList(pagination, loading) {
      // this.selectList = []
      this.list = [];
      let { current = 1, pageSize, val } = pagination || this.pagination;
      pageSize = pageSize ? pageSize : this.pageSizeC;
      let factoryId = window.localStorage.getItem("factoryId");
      this.form.validateFields((err, data) => {
        let { typeArr = [], ...newdata } = data;
        let params = {
          ...newdata,
          factoryId,
          current,
          // size: pageSize ? 2 :pageSize,
          size: pageSize,
          typeId: typeArr.length ? typeArr[typeArr.length - 1] : undefined,
        };
        if (val) {
          params = Object.assign({}, params, { name: val });
        }
        let _this = this.$http.get;
        if (loading) _this = this["$get"];
        _this(
          "/nhf-app/factorystaffraw/myRawpage",
          loading ? params : { params }
        ).then((res) => {
          let { success, data } = res;
          if (success) {
            let { records, current = 1, total = 0, size } = data;
            this.pagination.current = current;
            this.pagination.total = total;
            this.pagination.pageSize = size;
            records &&
              records.map((el) => {
                el.edit = false;
              });

            this.list = records || [];
            this.oldList = JSON.parse(JSON.stringify(records));
          } else {
            this.$message.error("查询失败");
          }
        });
      });
    },
    editRow(record, val, type) {
      // 编辑行
      if (val === "save" || val === "cancel") {
        if (val === "cancel") {
          this.list = JSON.parse(JSON.stringify(this.oldList));
        } else {
          if (this.loading) {
            // record.edit = false
            // this.recordObj = {}
            return;
          }
          let { name, rawTypeName, ...newVal } = record;
          this.loading = true;
          console.log(name, rawTypeName, newVal, '编辑行');
          this.$post("/nhf-app/factorystaffraw/update", newVal).then(() => {
            // let {success} = res;
            // if(success){
            //   this.$message.success('修改成功')
            // }else{
            //   this.$message.error('修改失败')
            // }
            this.recordObj = {};
            this.loading = false;
            record.edit = false;
            // this.getList(this.pagination,true)
          });
        }
      } else {
        this.list.map((el) => {
          el.edit = false;
          return el;
        });
        record.edit = type;
        this.recordObj = record;
        setTimeout(() => {
          this.$refs.getFocus[0].focus();
        }, 10);
      }
    },
    deleteData() {
      if (this.selectList.length === 0) {
        this.$message.warning("请选中需要删除的数据");
      } else {
        this.$confirm({
          title: "提示",
          content: "确认将选中的原料删除吗？",
          cancelText: "取消",
          okText: "确定",
          onOk: () => {
            // let idArr = this.selectList.
            // this.selectList.forEach(el => {
            //   idArr.push(this.list[el].id)
            // })
            let ids = this.selectList.join(",");
            this.$http
              .post(`/nhf-app/factorystaffraw/removeLogic?ids=${ids}`)
              .then((res) => {
                let { success } = res;
                if (success) {
                  this.$message.success("删除成功");
                  if (this.selectList.length === this.list.length) {
                    let current =
                      this.pagination.current - 1 === 0
                        ? 1
                        : this.pagination.current - 1;
                    this.getList({
                      current,
                      pageSize: this.pagination.pageSize,
                    });
                  } else {
                    this.getList();
                  }
                  this.selectList = [];
                  this.selectedRows = [];
                } else {
                  this.$message.error("删除失败");
                }
              });
          },
          onCancel() {
            console.log("取消删除。");
          },
        });
      }
    },
    scanPriceList(text, record) {
      // 查看价格
      this.$store.commit("saveMenuInformation", {
        name: record.name,
        hierarchy: 3,
      });
      this.$router.push(
        `/mainPage/materialManagement/nutrient-list?name=${record.name}&id=${record.rawId}&isFucCal=${record.isFucCal}`
      );
    },
    replaceSubmit() {
      this.showReplace = false;
      let factoryId = window.localStorage.getItem('factoryId');
      let staffId = window.localStorage.getItem('staffId');
      if (!factoryId || !staffId) return;
      this.$http.post(`/nhf-app/factorystaffraw/factoryRawImport?factoryId=${factoryId}&staffId=${staffId}`,
        this.dataList).then(res => {
          let { success } = res || {};
          if (success) {
            this.$message.success('操作成功');
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    addSubmit() {
      // 防止重复点击
      if (this.submitLoading) {
        return;
      }
      
      // 新增提交
      let rows = this.$refs["add"].selectedRows;
      // let chooseList = this.$refs['add'].selectList
      console.log(rows);
      if (!rows || rows.length === 0) {
        this.$message.warning("请选择需要添加的原料");
        return;
      }
      
      // 设置加载状态
      this.submitLoading = true;
      
      let factoryId = window.localStorage.getItem("factoryId");
      // chooseList && chooseList.forEach(item => {
      //   ids.push(item.id)
      // })
      // 过滤重复的 rawId，保留最后一个
      const uniqueRows = [];
      const seenIds = new Set();
      const duplicateItems = []; // 记录重复的项目
      
      // 从后往前遍历，保留最后出现的项目
      for (let i = rows.length - 1; i >= 0; i--) {
        const item = rows[i];
        if (!seenIds.has(item.id)) {
          seenIds.add(item.id);
          uniqueRows.unshift(item); // 使用 unshift 保持原有顺序
        } else {
          // 记录重复的项目
          duplicateItems.push({
            index: i,
            item: item,
            name: item.name || item.code || `ID: ${item.id}`
          });
        }
      }
      
      // 输出去重日志
      if (duplicateItems.length > 0) {
        console.log('=== 原料去重日志 ===');
        
        console.log(`原始选择数量: ${rows.length}`);
        console.log(`去重后数量: ${uniqueRows.length}`);
        console.log(`过滤掉的重复项目:`, duplicateItems);
        console.log('=== 去重日志结束 ===');
      }
      
      let data = {
        condRawInfoList: uniqueRows.map(item => { return { rawId: item.id, turnoverDay: item.turnoverDay }; }),
        factoryId,
      };
      this.$http
        .post("/nhf-app/factorystaffraw/saveFactoryStaffRawIds", data)
        .then((res) => {
          let { success } = res;
          if (success) {
            this.$message.success("新增成功");
          } else {
            this.$message.error("新增失败");
          }
          this.getList();
          this.showAddFunc();
        })
        .catch((error) => {
          console.error('提交失败:', error);
          this.$message.error("新增失败，请重试");
        })
        .finally(() => {
          // 重置加载状态
          this.submitLoading = false;
        });
    },
    showAddFunc() {
      // 新增显示或关闭
      if (this.$refs.add && this.$refs.add.isChange) {
        this.getList();
      }
      this.showAdd = !this.showAdd;
      
      // 关闭模态框时重置加载状态
      if (!this.showAdd) {
        this.submitLoading = false;
      }
    },
    showReplaceFunc() {
      this.showReplace = !this.showReplace;
    },
    showEditFunc(type) {
      // 编辑显示或关闭
      if (type === "edtiBtn") {
        if (this.selectList.length > 1) {
          this.$message.warning("编辑只能选中一条数据");
        } else if (this.selectList.length === 0) {
          this.$message.warning("请选中需要编辑的数据");
        } else {
          this.showEdit = !this.showEdit;
        }
      } else {
        this.showEdit = !this.showEdit;
      }
    },

    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        // this.$emit('getTypeList',{targetOption,id:targetOption.id})
        this.getTypeList(targetOption.id, targetOption) || [];
        // this.typeList = [...this.typeList];
      }, 0);
    },
    onChange(value) {
      console.log(value);
    },
    coverData(record) {
      this.$refs.CoverModal.init(record);
    },
    copyData(record) {
      let data;
      if (record === 'copy') { data = this.selectedRows; }
      else { data = [record]; }
      this.$refs.CopyModal.init(data);
    },
    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },

    // 表格列筛选
    onColFilterChange(val) {
      this.colFilterResult = val;
      window.localStorage.setItem('MaterialManagementColsFilterResult', val);
    },
    // 批量应用LIMS检测数据
    batchLims() {
      this.batchlimsVisible = true;
    },
    onBatchLimsClose(calAndSaveFlag) {
      if (calAndSaveFlag) {
        this.getList();
      }
      this.batchlimsVisible = false;
    },

    turnoverDayTip(record) {
      //purchaseClassCode 1001: 大料，其余为小料
      if ((record.purchaseClassCode === '1001' && record.turnoverDay > 15)
        || (record.purchaseClassCode !== '1001' && record.turnoverDay > 30)) {
        return true;
      }
    },

    viewBatchStorage(record) {
      this.batchStorageModalVisible = true;
      this.batchStorageLoading = true;
      this.batchStorageData = [];
      this.$http.get(
        `/nhf-app/platformfactoryrawstockbatch/getByFactoryAndRaw?current=1&size=200&factoryId=${record.factoryId}&rawId=${record.rawId}`)
        .then((res) => {
          let { msg, success, data } = res;
          if (success) {
            this.batchStorageData = data.records;
            this.batchStorageModalVisible = true;
          } else {
            this.$message.error(msg);
          }
          this.batchStorageLoading = false;
        });
    },
    onBatchStorageClose() {
      this.batchStorageModalVisible = false;
    },

    // 排序相关方法
    handlerMore({ key }, record) {
      if (key == 2) {
        this.sortData = record;
        this.showSortModal();
      } else if (key == 3) {
        // 查看功能，可以根据需要实现
        console.log('查看功能', record);
      }
    },
    hideSortModal(type) {
      if (type) this.getList();
      this.sortModalVisible = false;
    },
    showSortModal() {
      this.sortModalVisible = true;
    },

    // 统一的验证和修正值的方法
    validateAndCorrectValue(val, field) {
      let priceList = [
        "privateContractPrice",
        "privateStockPrice",
        "privateMarketPrice",
        "privatePredictionPrice",
      ];

      if (priceList.includes(field)) {
        if (val < 0) {
          this.$message.warning("价格不能小于0");
          return 0;
        } else if (val > 9999999999) {
          this.$message.warning("价格不能大于9999999999");
          return 9999999999;
        }
        return val;
      } else if (field === "fixRatio") {
        console.log(val, 'val=====》');
        if (val !== null && val !== undefined) {
          if (val < 0) {
            this.$message.warning("取整系数不能小于0");
            return null;
          } else if (val < 0.001) {
            this.$message.warning("取整系数小于0.001，已设置为空值");
            return null;
          } else if (val > 100) {
            this.$message.warning("取整系数不能大于100");
            return 100;
          }
        }
        return val;
      } else if (field === "minWeightVal") {
        if (val || val === 0) {
          if (val <= 0) {
            this.$message.warning("最小称量量不能小于等于0");
            return 0.001;
          } else if (val > 100) {
            this.$message.warning("最小称量量不能大于100");
            return 100;
          }
        }
        return val;
      }
      return val;
    },
    onTurnoverOrderChange() {
      this.form.setFieldsValue({ storageWeightOrder: undefined });
    },
    onStorageOrderChange() {
      this.form.setFieldsValue({ turnoverDayOrder: undefined });
    }
  },
};
</script>
<style lang="scss">
.modalStyle {
  .ant-modal-header {
    padding: 0;
    border-bottom: none;
  }

  .ant-modal-close-x {
    width: 36px;
    height: 36px;
    line-height: 36px;
  }
}
</style>

<style lang="scss" scoped>
.listContent {
  .tableBox {
    height: calc(100% - 112px);
  }
}

.rightBox {
  float: right;
}

.resetBox {
  background: #1890ff;
  // padding: 3px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  // width: 23px;
  // height: 23px;
  // line-height: 18px;
  height: 27px;
  width: 27px;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
  text-align: center;
}

.col-filter-menu {
  padding: 5px 15px;

  ::v-deep .ant-checkbox-group-item {
    display: block;
    margin: 10px 0;
  }
}
</style>
